import { render, staticRenderFns } from "./wakeUpList.vue?vue&type=template&id=38684708"
import script from "./wakeUpList.vue?vue&type=script&lang=js"
export * from "./wakeUpList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports